export enum AccessCodeHistoryType{
	New = 0,
	Regenerate = 1,
	Forward = 2,
	Relocate = 3,
	Cancel = 4,
	Refund = 5,
	AccessRequest = 6,
	Returned = 7,
	ValidAccess = 8
}


// WEBPACK FOOTER //
// ./src/app/models/accesscode-history-type.enum.ts